module.exports = __webpack_public_path__ + "img/logo.e5f7542f.png";